import { ErrorsAPIData } from '@common/types';

export const createNotifyForMoveWPToTrip = (error: ErrorsAPIData['data']) => {
  if (error?.errors) {
    return Object.keys(error.errors).map((id: string) => `№${id}: ${error.errors[id]}`);
  }
  return undefined;
};
